module.exports = "https://r.nearpod.com/assets/media/image/delete-btn-0c05bdfb76a7bb883a1d85f9a073046b.svg";